import axios from "../utils/axios.wrapper";

export const getMenus = async () => {
  const { data } = await axios.get("/Menu");
  return data.items || data;
};

export const createMenu = async (menu) => {
  const { data } = await axios.post("/Menu/create", menu);
  return data;
};

export const updateMenu = async (id, menu) => {
  const { data } = await axios.put(`/Menu/${id}`, menu);
  return data;
};

export const deleteMenu = async (id) => {
  const { data } = await axios.delete(`/Menu/${id}`);
  return data;
};

export const menuService = { getMenus, createMenu, updateMenu, deleteMenu };
